/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import InnerContent from "./InnerContent/InnerContent";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { useDispatch, useSelector } from "react-redux";
import { saveUserDetails } from "store/reducers/UserDetails/UserDetailsSlice";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
       height:'100vh',
    position:'relative',
  },
}));
const MainContainer = ({featureFlagState}) => {
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [showSidebar, setShowSidebar] = React.useState(true);
  const { authToken } = useSelector((state) => state.login.authData);
   const [callInProgress, setCallInProgress] = useState(false);
  const [userDetailsData, setUserDetailsData] = useState({});
   const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastMessageType, setToastMessageType] = useState("");
     const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    getUserDetails();
  },[])
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };
  const getUserDetails = async () => {
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    if(result?.data?.error_code){
      toastUpdate("Error",result?.data?.user_description,true);
    }else{
      setUserDetailsData(result?.data);
      dispatch(
        saveUserDetails({
          userDetails: result?.data,
        })
      );
    }
  };
  const classes = useStyles();
  return (
    <div className={classes.mainContainer}>
      {callInProgress ? (
        <CircularProgresss callInProgress={callInProgress} />
      ) : userDetailsData && Object.keys(userDetailsData).length > 0 ? (
        <>
        <Header
          handleDrawerToggle={handleDrawerToggle}
          handleSidebarToggle={handleSidebarToggle}
          userDetailsData={userDetailsData}
        />
        <InnerContent
          handleSidebarToggle={handleSidebarToggle}
          handleDrawerToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
          userDetailsData={userDetailsData}
          featureFlagState={featureFlagState}
        />
        <Footer featureFlagState={featureFlagState}/>
          </>
      ) : null}
      {toast && (
              <ToastModal
                toastMessage={toastMessage}
                toastMessageType={toastMessageType}
                toastUpdate={toastUpdate}
              />
            )}
    </div>
  );
};

export default MainContainer;
